import { AnyAction } from 'redux';
import { RootState } from '../..';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import apis from '../../../utils/apis';
import { showFeedbackModal } from '../UserFeedbackActions';
import {
  CREATE_TEAM_FAILURE, CREATE_TEAM_REQUEST, CREATE_TEAM_SUCCESS, FETCH_CASES_FIRM_FAILURE, FETCH_CASES_FIRM_REQUEST,
  FETCH_CASES_FIRM_SUCCESS, FETCH_EXTERNAL_COLLABORATORS_FAILURE, FETCH_EXTERNAL_COLLABORATORS_REQUEST, FETCH_EXTERNAL_COLLABORATORS_SUCCESS, FETCH_LAWYERS_FIRM_FAILURE, FETCH_LAWYERS_FIRM_REQUEST, FETCH_LAWYERS_FIRM_SUCCESS, FETCH_LEGAL_SUBJECTS_TEAM_FAILURE,
  FETCH_LEGAL_SUBJECTS_TEAM_REQUEST, FETCH_LEGAL_SUBJECTS_TEAM_SUCCESS, FETCH_LEGAL_TEAMS_FAILURE, FETCH_LEGAL_TEAMS_REQUEST, FETCH_LEGAL_TEAMS_SUCCESS,
  FETCH_TASK_SUCCESS, FETCH_TEAM_FAILURE, FETCH_TEAM_REQUEST, FETCH_TEAM_SUCCESS, SET_LICENSE_DATA, SET_LICENSE_REQUESTS
} from '../../types';
import { handleApiError } from '../utils/utils';

export const fetchLawyersRequest = (): AnyAction => ({
  type: FETCH_LAWYERS_FIRM_REQUEST,
});

export const fetchLawyersSuccess = (lawyers: any[]): AnyAction => ({
  type: FETCH_LAWYERS_FIRM_SUCCESS,
  payload: lawyers,
});

// export const fetchLawyersFailure = (error: string): AnyAction => ({
//   type: FETCH_LAWYERS_FIRM_FAILURE,
//   payload: error,
// });

export const fetchCasesRequest = (): AnyAction => ({
  type: FETCH_CASES_FIRM_REQUEST,
});

export const fetchCasesSuccess = (cases: any[]): AnyAction => ({
  type: FETCH_CASES_FIRM_SUCCESS,
  payload: cases,
});

export const fetchCasesFailure = (error: string): AnyAction => ({
  type: FETCH_CASES_FIRM_FAILURE,
  payload: error,
});

export const fetchSubjectsRequest = (): AnyAction => ({
  type: FETCH_LEGAL_SUBJECTS_TEAM_REQUEST,
});

export const fetchSubjectsSuccess = (subjects: any[]): AnyAction => ({
  type: FETCH_LEGAL_SUBJECTS_TEAM_SUCCESS,
  payload: subjects,
});

export const fetchSubjectsFailure = (error: string): AnyAction => ({
  type: FETCH_LEGAL_SUBJECTS_TEAM_FAILURE,
  payload: error,
});

export const fetchTeamsRequest = (): AnyAction => ({
  type: FETCH_LEGAL_TEAMS_REQUEST,
});

export const fetchTeamsSuccess = (teams: any[]): AnyAction => ({
  type: FETCH_LEGAL_TEAMS_SUCCESS,
  payload: teams,
});

export const fetchTeamsFailure = (error: string): AnyAction => ({
  type: FETCH_LEGAL_TEAMS_FAILURE,
  payload: error,
});

export const fetchTeamRequest = (): AnyAction => ({
  type: FETCH_TEAM_REQUEST,
});

export const fetchTeamSuccess = (team: any[]): AnyAction => ({
  type: FETCH_TEAM_SUCCESS,
  payload: team,
});

export const fetchTeamFailure = (error: string): AnyAction => ({
  type: FETCH_TEAM_FAILURE,
  payload: error,
});

export const createTeamRequest = (): AnyAction => ({
  type: CREATE_TEAM_REQUEST,
});

export const createTeamSuccess = (team: any): AnyAction => ({
  type: CREATE_TEAM_SUCCESS,
  payload: team,
});

export const fetchTasksSuccess = (tasks: any): AnyAction => ({
  type: FETCH_TASK_SUCCESS,
  payload: tasks,
});

export const createTeamFailure = (error: string): AnyAction => ({
  type: CREATE_TEAM_FAILURE,
  payload: error,
});

export const setLicenseRequest = (LicenseRequest: boolean): AnyAction => ({
  type: SET_LICENSE_REQUESTS,
  payload: LicenseRequest
})

export const setLicenseData = (licenceLimitExceded: boolean, totalLicenseCount: number, licenseUsed: number): AnyAction => ({
  type: SET_LICENSE_DATA,
  payload: {
    licenceLimitExceded,
    totalLicenseCount,
    licenseUsed
  }
})

export const getAllLawyers = (userID: string) => {
  return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
    dispatch(fetchLawyersRequest());
    try {
      const response = await apis({
        method: 'POST',
        url: 'lawfirm/getAllLawyers',
        data: { UserID: userID },
      });
      const lawyers = await response.data;
      dispatch(fetchLawyersSuccess(lawyers));
    } catch (error) {
      handleApiError(error, dispatch);
    }
  };
};

export const getAllCases = (userID: string) => {
  return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
    dispatch(fetchCasesRequest());
    try {
      const response = await apis({
        method: 'POST',
        url: 'lawfirm/getCases',
        data: { LawfirmID: userID },
      });
      const cases = response.data;
      dispatch(fetchCasesSuccess(cases));
    } catch (error) {
      handleApiError(error, dispatch);
    }
  };
};

export const getLegalSubjects = () => {
  return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
    dispatch(fetchSubjectsRequest());
    try {
      const response = await apis({
        method: 'GET',
        url: 'lawfirm/getLegalSubjects',
      });
      const subjects = response.data;

      dispatch(fetchSubjectsSuccess(subjects));
    } catch (error) {
      handleApiError(error, dispatch);
    }
  };
};

export const getLegalTeams = (userID: string) => {
  return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
    dispatch(fetchTeamsRequest());
    try {
      const response = await apis({
        method: 'POST',
        url: '/teams/get_legal_teams',
        data: { LawfirmID: userID }
      });
      const teams = response.data;
      dispatch(fetchTeamsSuccess(teams));
    } catch (error) {
      handleApiError(error, dispatch);
    }
  };
};

export const getTeam = (TeamId: string) => {
  return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
    dispatch(fetchTeamRequest());
    try {
      const response = await apis({
        method: 'POST',
        url: '/teams/get_team_details',
        data: { LegalTeamID: TeamId }
      });
      if (response && response.status === 200) {
        const team = response.data;
        dispatch(fetchTeamSuccess(team));

      } else {
        handleApiError(response, dispatch);
      }
    } catch (error) {
      handleApiError(error, dispatch);
    }
  };
};

export const createTeam = (teamData: any) => {
  return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
    dispatch(createTeamRequest());
    try {
      const response = await apis({
        method: 'POST',
        url: '/teams/add_team',
        data: teamData,
      });

      if (response && response.status === 200) {
        const team = response.data;
        dispatch(createTeamSuccess(team));
        dispatch(showFeedbackModal({
          showModal: true,
          message: response.data.message || 'Team added',
          modalType: 'success',
          duration: 3000
        }));
      } else {
        handleApiError(response, dispatch);
      }
    } catch (error) {
      handleApiError(error, dispatch);
    }
  };
};



// export const RequestLicenses = (RequestContent: string, LicenseCount: number) => {
//   return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
//     try {
//       const response = await apis({
//         method: 'POST',
//         url: 'lawfirm/license/request',
//         data: {
//           RequestContent, LicenseCount
//         }
//       });
//       if (response && response.status === 200) {
//         dispatch(FetchLicenseRequests())
//         dispatch(showFeedbackModal({
//           showModal: true,
//           message: response.data.message,
//           modalType: 'success',
//           duration: 3000
//         }))
//       } else {
//         handleApiError(response, dispatch);
//       }
//     } catch (e) {
//       handleApiError(e, dispatch);

//     }
//   }
// }


// export const FetchLicenseRequests = () => {
//   return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
//     try {
//       const response = await apis({
//         method: 'GET',
//         url: 'lawfirm/fetch/license/request',
//       });

//       if (response && response.status === 200) {
//         const data = await response.data
//         dispatch(setLicenseRequest(data.request_exist))
//         dispatch(setLicenseData(data.limit_exceded, data.Total_Licenses, data.license_used))
//       } else {
//         handleApiError(response, dispatch);
//       }
//     } catch (e) {
//       handleApiError(e, dispatch);
//     }
//   }
// }


export interface ExternalCollaborator {
  ExternalID: string;
  InvitationID?: string | null;
  Email: string;
  Name: string;
  ProfilePicture?: string | null;
  InvitationStatus?: string;
  AccessLevel?: string;
  CaseID: string;
  CaseName: string;
  OrgStatus: string;
  LinkedOrgName?: string;
}

export const fetchExternalCollaborators = (params: {
  search?: string;
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
} = {}): ThunkAction<Promise<ExternalCollaborator[]>, RootState, unknown, AnyAction> => async (dispatch) => {
  dispatch({ type: FETCH_EXTERNAL_COLLABORATORS_REQUEST });

  try {
    const {
      search = "",
      sortBy = "",
      sortOrder = "asc",
      page = 1,
      limit = 10,
    } = params;

    const response = await apis({
      method: "GET",
      url: "/external/collaborator/list",
      params: {
        search,
        sortBy,
        sortOrder,
        page,
        limit,
      },
    });

    if (response && response.status === 200) {
      const collaborators = response.data.collaborators || [];
      const total = response.data.pagination?.total || 0;
      const currentPage = response.data.pagination?.page || 1;
      const totalPages = response.data.pagination?.pages || 1;

      dispatch({
        type: FETCH_EXTERNAL_COLLABORATORS_SUCCESS,
        payload: {
          collaborators,
          total,
          currentPage,
          totalPages,
        },
      });

      return collaborators;
    } else {
      dispatch({
        type: FETCH_EXTERNAL_COLLABORATORS_FAILURE,
        payload: "Failed to fetch external collaborators.",
      });
      return [];
    }
  } catch (error: any) {
    console.error("Error fetching external collaborators:", error);
    dispatch({
      type: FETCH_EXTERNAL_COLLABORATORS_FAILURE,
      payload: error.message || "An error occurred while fetching external collaborators.",
    });
    return [];
  }
};